/*
ecommerceClient.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { axiosInstance } from './apiClient';

export const getSummary = (deviceSerial:string, appId: string) =>
  axiosInstance
    .get(`/ecommerce/${deviceSerial}/summary`, {
      params: { appId }
    })
    .then(r => r.data);

export const getRemainingCredits = (deviceSerial:string, appId: string, unitName: string) =>
  axiosInstance
    .get(`/ecommerce/${deviceSerial}/usage`, {
      params: { appId, unitName }
    })
    .then(r => r.data);

export const getCreditsConsumed = (deviceSerial: string, appId: string, unitName: string) =>
  axiosInstance
    .get(`/ecommerce/${deviceSerial}/consumed`, {
      params: { appId, unitName }
    })
    .then(r => r.data);

export const trackCreditConsumption = (deviceSerial: string, appId: string, usage: number, unit: string) =>
  axiosInstance
    .post(`/ecommerce/track`, {
      unit,
      appId,
      deviceSN: deviceSerial,
      usage
    })
    .then(r => r.data);